import React, { useEffect, useState } from "react"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config.ts"
import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"

import { AUTH_CONFIG } from "../../../config/auth.config"
import { useAppDispatch } from "../../../store/appDispatch.hook"
import { useAppSelector } from "../../../store/selectors/app.selector"
import { authSelector } from "../../../store/selectors/auth.selector"
import { authResendMfaCode } from "../../../store/thunks/auth.thunks"

export const ResendSmsCodeComponent: React.FunctionComponent<any> = props => {
    const authState = useAppSelector(authSelector)
    const dispatch = useAppDispatch()

    const [codeResendWaitSeconds, setCodeResendWaitSeconds] =
        useState<number>(0)

    const [codeResentAt, setCodeResentAt] = useState<number>(
        new Date().getTime(),
    )

    const [codeTriggeredCount, setCodeTriggeredCount] = useState<number>(1)

    // interval for when code can be resent
    useEffect(() => {
        const calculateCodeResendWaitSeconds = () => {
            const secondsToWait = Math.max(
                0,
                Math.floor(
                    (codeResentAt +
                        AUTH_CONFIG.mfaCodeSendDelayMS -
                        new Date().getTime()) /
                        1000,
                ),
            )

            setCodeResendWaitSeconds(secondsToWait)
        }

        const intervalId = setInterval(calculateCodeResendWaitSeconds, 1000)

        calculateCodeResendWaitSeconds()

        return () => {
            clearInterval(intervalId)
        }
    }, [codeResentAt])

    const onResendCode = () => {
        if (codeResendWaitSeconds) {
            return
        }

        dispatch(
            authResendMfaCode({
                payload: {
                    loginData: authState.loginData,
                },
                onSuccess: () => {
                    setCodeResentAt(new Date().getTime())

                    setCodeTriggeredCount(current => {
                        return current + 1
                    })
                },
            }),
        )
    }

    if (codeTriggeredCount >= AUTH_CONFIG.mfaCodeSendMaxAttempts) {
        return null
    }

    return (
        <div
            className={`
                relative
                ${props.className}
            `}
        >
            <PrimaryText className="inline-block">
                Didn't get the code?
            </PrimaryText>

            <div
                className="inline-block ml-[8px] mr-[16px]"
                onClick={
                    !!codeResendWaitSeconds || props.isCtaLoading
                        ? undefined
                        : onResendCode
                }
            >
                <PrimaryText
                    typography="buttonText"
                    color={NIRVANA_COLORS.brand.vibrantPurple}
                    underline
                    className={
                        !!codeResendWaitSeconds || props.isCtaLoading
                            ? "opacity-75 cursor-not-allowed"
                            : "cursor-pointer"
                    }
                >
                    Resend code
                </PrimaryText>
            </div>

            {!!codeResendWaitSeconds && (
                <PrimaryText
                    italic={true}
                    typography="caption"
                    className="inline-block"
                >
                    Available in {codeResendWaitSeconds} seconds
                </PrimaryText>
            )}
        </div>
    )
}
